import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Star } from "lucide-react";

export default function MyReviews() {
  const [reviews, setReviews] = useState([]);
  useEffect(() => {
    api.get("/reviews/my-reviews").then(r => setReviews(r.data));
  }, []);
  return (
    <div className="space-y-4">
      <h2 className="font-display text-2xl font-bold text-[#1a3c5e]">Reviews</h2>
      {reviews.length === 0 ? (
        <div className="bg-white rounded-2xl p-10 text-center text-gray-500 border border-[#1a3c5e]/10">No reviews yet.</div>
      ) : (
        <div className="space-y-3">
          {reviews.map(r => (
            <div key={r.id} className="bg-white rounded-2xl border border-[#1a3c5e]/10 p-5">
              <div className="flex items-center justify-between mb-2">
                <div className="font-semibold text-[#1a3c5e]">{r.reviewer_name} · {r.city}</div>
                <div className="flex">{[1,2,3,4,5].map(i => <Star key={i} className={`w-3.5 h-3.5 ${i <= r.rating ? "fill-[#F7941D] text-[#F7941D]" : "text-gray-300"}`} />)}</div>
              </div>
              <p className="text-sm text-gray-700">{r.review_text}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
